import _ from "lodash"

export const reduceKeys = {
  form(state = {}, action) {
    switch (action.type) {
      case "FORM_SET":
        return Object.assign({}, state, {[action.name]: action.value})
      case "FORM_CLEAR":
        return _.omit(state, action.name)
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/units/UnitsReducer.js